import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { fromJS, is } from 'immutable';
import { useDispatch, useSelector } from 'react-redux';

import { Sidebar } from 'semantic-ui-react';

import { DataGrid } from '../../Common';

import Actions from './actions';

import { Features } from '../../../Constants';

const Detail = lazy(() => import('./Detail'));

export default function SettingBanner(props) {
    const dispatch = useDispatch();

    const loading_index = useSelector(
        state => state.SettingBannerReducer.get('loading_index'),
        (a, b) => is(a, b)
    );

    const loading_show = useSelector(
        state => state.SettingBannerReducer.get('loading_show'),
        (a, b) => is(a, b)
    );

    const banners = useSelector(
        state => state.SettingBannerReducer.get('banners'),
        (a, b) => is(a, b)
    );

    const banner = useSelector(
        state => state.SettingBannerReducer.get('banner'),
        (a, b) => is(a, b)
    );

    const search = useSelector(
        store => store.SettingBannerReducer.get('search'),
        (a, b) => is(a, b)
    );

    const defaultColumns = useSelector(
        store => store.SettingBannerReducer.get('columns'),
        (a, b) => is(a, b)
    );

    const columns = useSelector(
        store => store.MainReducer.getIn(['gui', 'Banner'], defaultColumns),
        (a, b) => is(a, b)
    ).toJS();

    useEffect(() => {
        dispatch(Actions.requests());
    }, [search]);

    const handleSearch = (evt, values) => {
        const { name, value } = values;
        if (name) {
            dispatch(Actions.search(search.set(name, value instanceof Array ? value.join(',') : value)));
        } else {
            dispatch(Actions.search(search.merge(fromJS(values))));
        }
    };

    const handleAction = (evt, { action, selected }) => {
        switch (action) {
            case 'add':
                dispatch(Actions.show());
                return DetailRef?.current?.handleOpen();
            case 'refresh':
                return dispatch(Actions.requests());
            case 'update':
                return dispatch(Actions.create());
            case 'destroy':
                return dispatch(Actions.destroy());

            default:
        }
    };

    const handleSelect = row => {
        dispatch(Actions.request(row.id));
        return DetailRef?.current?.handleOpen();
    };

    const handleColumnChange = columns => {};

    const handleChange = (evt, values) => {
        const { name, value } = values;

        if (name) {
            dispatch(Actions.show(banner.set(name, fromJS(value))));
        } else {
            dispatch(Actions.show(banner.merge(fromJS(values))));
        }
    };

    const DetailRef = useRef();

    const features = Features.filter(({ admin }) => admin);

    return (
        <div className="flexHorizontalContent">
            <Sidebar.Pushable className="flexHorizontalContent">
                <DataGrid
                    loading={loading_index}
                    columns={columns}
                    rows={banners}
                    defaultSortColumns={[{ columnKey: 'name', direction: 'ASC' }]}
                    onAction={handleAction}
                    onSelect={handleSelect}
                    onColumnChange={handleColumnChange}
                />
                <Suspense fallback={null}>
                    <Detail
                        features={features}
                        ref={DetailRef}
                        loading={loading_show}
                        banner={banner}
                        onAction={handleAction}
                        onChange={handleChange}
                    />
                </Suspense>
            </Sidebar.Pushable>
        </div>
    );
}

export { default as SettingBannerReducer } from './reducers';
export { default as SettingBannerAction } from './actions';
